import { getBanks } from '@/services/banks.service';
import {
  getAffiliate,
  getAffiliateHierarchies,
  getAffiliateRepresentations,
  getAffiliateRetirementTypes,
} from '@/services/affiliates.service';
import { getBloodTypes } from '@/services/user.service';
import { queryDestinations } from '@/services/destinations.service';
import { redirectNotFound } from '@/utils/errorRedirect';

const Model = {
  namespace: 'affiliateSettings',
  state: {
    affiliate: null,
    isLoadingAffiliate: true,
    banks: [],
    bloodTypes: [],
    hirarchies: [],
    destinations: [],
    retirementTypes: [],
  },

  effects: {
    *fetchCurrentAffiliate({ payload }, { call, put, all }) {
      try {
        const [affiliate, representatives] = yield all([
          call(getAffiliate, payload),
          call(getAffiliateRepresentations, payload),
        ]);
  
        yield put({
          type: 'saveAffiliate',
          payload: {
            affiliate: affiliate.data,
            representatives: representatives.data,
          },
        });
      } catch (error) {
        redirectNotFound(error);
      }
    },

    *fetchData(_, { call, put, all }) {
      const [bloodTypes, destinations, retirementTypes, hirarchies] = yield all([
        call(getBloodTypes),
        call(queryDestinations),
        call(getAffiliateRetirementTypes),
        call(getAffiliateHierarchies),
      ]);
      yield put({
        type: 'save',
        payload: {
          bloodTypes: bloodTypes.data,
          destinations: destinations.data,
          retirementTypes: retirementTypes.data,
          hirarchies: hirarchies.data,
        },
      });
    },

    *fetchBanks(_, { call, put }) {
      yield put({
        type: 'changeLoading',
        payload: true,
      });

      const response = yield call(getBanks);
      yield put({
        type: 'setBanks',
        payload: response.data,
      });
    },
  },
  reducers: {
    saveAffiliate(state, action) {
      return { ...state, ...action.payload, isLoadingAffiliate: false };
    },

    save(state, action) {
      return { ...state, ...action.payload };
    },

    setBanks(state, action) {
      return { ...state, banks: action.payload };
    },
  },
};
export default Model;
